(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('UserDetailService', ['$rootScope', 'SharedAgendaService', 'AdministrationService', UserDetailServiceFn]);

    /* main user service */
    function UserDetailServiceFn($rootScope, SharedAgendaService, AdministrationService) {

        var data = {
            form: {
                //form validation -> default not valid on new user
                personal: true,
                account: true,
            },
            groupPractices: []
        };

        var service = {
            data: data,
            loadGroupPractices: loadGroupPractices,
        };

        // load group practices
        function loadGroupPractices() {
            data.groupPractices = [];
            return AdministrationService.grouppractices(true).then(function (result) {
                data.groupPractices = result;
                return data.groupPractices;
            });
        }

        return service;
    }
})();